import React from 'react';
import { Text } from 'v3/components';
import { styles } from '../styles';

export default function FeedbackMessages({
  cols,
  error,
  feedbackStatus,
  isMobile,
  loading,
  model,
  uniqueLock,
}) {
  const feedbackMessage =
    feedbackStatus === 'success'
      ? 'Parabéns! Seu treinamento foi concluído com sucesso. O certificado de conclusão foi enviado para o e-mail cadastrado e já está disponível para consulta.'
      : feedbackStatus === 'warning'
      ? 'Treinamento não concluído. É necessário atingir pelo menos 70% de acertos para ser aprovado. Revise o conteúdo responda novamente.'
      : feedbackStatus === 'info'
      ? uniqueLock?.reason || 'Esse link já foi respondido.'
      : '';

  const feedbackType = feedbackStatus === 'warning' ? 'warning' : 'success';

  return (
    <>
      {!!error && (
        <div style={styles.messageWrap('error')}>
          <div style={styles.messageBox('error', cols, isMobile)}>
            <Text color="danger">{error}</Text>
          </div>
        </div>
      )}

      {!!feedbackMessage && (
        <div style={styles.messageWrap(feedbackType)}>
          <div style={styles.messageBox(feedbackType, cols, isMobile)}>
            <div style={styles.successContent(isMobile)}>
              <Text
                color={feedbackType === 'success' ? 'success' : 'dark'}
                style={
                  feedbackType === 'warning'
                    ? { color: '#92400E', fontWeight: 800 }
                    : undefined
                }
              >
                {feedbackMessage}
              </Text>
            </div>
          </div>
        </div>
      )}

      {loading ? (
        <div style={styles.messageWrap('info')}>
          <div style={styles.messageBox('info', cols, isMobile)}>
            <Text>Carregando...</Text>
          </div>
        </div>
      ) : !model && !error ? (
        <div style={styles.messageWrap('info')}>
          <div style={styles.messageBox('info', cols, isMobile)}>
            <Text color="gray">Treinamento não encontrado.</Text>
          </div>
        </div>
      ) : null}
    </>
  );
}
